<template>
  <div id="app">
    <router-view />
    <!-- 添加确认对话框 -->
    <el-dialog
      title="提示："
      :visible.sync="showTimeoutDialog"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <span style="font-size: 16px; color: #333; line-height: 30px">
        检测到长时间
        <b style="color: #fc6d08">(30分钟)</b>
        未操作！
        <br />
        请刷新界面，以获取最新数据！
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleStayOnPage">关闭</el-button>
        <el-button type="primary" size="small" @click="handleRefreshPage">刷新页面</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { microAppForceSetGlobalData } from "@/micro/micro-app-utils"
import userTrackingService from "@/services/userTrackingService"

export default {
  name: "App",
  data() {
    return {
      showTimeoutDialog: false,
      idleTimer: null,
      idleTimeout: 30 * 60 * 1000 // 30分钟转换为毫秒
    }
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar.opened
    }
  },
  watch: {
    sidebar: {
      handler(newVal) {
        // 监听侧边栏状态
        microAppForceSetGlobalData({ type: "sidebarOpened", data: this.sidebar })
      }
    },
    $route() {
      // 路由变化时重新设置定时器
      this.resetIdleTimer()
    }
  },
  mounted() {
    this.setupIdleTimer()
    // 添加事件监听
    window.addEventListener("mousemove", this.resetIdleTimer)
    window.addEventListener("keypress", this.resetIdleTimer)
    window.addEventListener("click", this.resetIdleTimer)
    window.addEventListener("scroll", this.resetIdleTimer)

    const userData = localStorage.getItem("login_user")
    if (userData) {
      const parseData = JSON.parse(userData)
      if (["太阳", "测试马修诺", "马修诺", "浊清", "流光", "白富"].includes(parseData.userName)) {
        // 监听用户点击事件
        document.addEventListener("click", event => {
          // 忽略一些特定元素的点击，比如系统对话框等
          if (event.target.closest(".el-dialog")) {
            return
          }

          // 记录用户操作
          userTrackingService.trackEvent(event)
        })
      }
    }
  },
  beforeDestroy() {
    // 清理事件监听
    window.removeEventListener("mousemove", this.resetIdleTimer)
    window.removeEventListener("keypress", this.resetIdleTimer)
    window.removeEventListener("click", this.resetIdleTimer)
    window.removeEventListener("scroll", this.resetIdleTimer)
    // 清除定时器
    if (this.idleTimer) {
      clearTimeout(this.idleTimer)
    }
  },
  methods: {
    setupIdleTimer() {
      this.resetIdleTimer()
    },
    resetIdleTimer() {
      if (this.idleTimer) {
        clearTimeout(this.idleTimer)
      }

      // 只在特定URL时才启动空闲检测
      const currentUrl = window.location.href
      if (currentUrl.includes("voyager#/voyager/wxChat")) {
        this.idleTimer = setTimeout(() => {
          this.showTimeoutDialog = true
        }, this.idleTimeout)
      }
    },
    handleStayOnPage() {
      this.showTimeoutDialog = false
      this.resetIdleTimer()
    },
    handleRefreshPage() {
      window.location.reload()
    }
  }
}
</script>
